import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'
import Typography from '../../typography'
import { ReactNode } from 'react'

export const ItemContainer = styled('div')<{ theme?: TTheme }>`
    width: 100%;
    display: flex;
    flex-direction: column;
`

export const TypographyContainer = styled('div')<{
    disabled?: boolean
    isTitle?: boolean
    isLastItem?: boolean
    leftIcon?: ReactNode
    rightElement?: ReactNode
    theme?: TTheme
    selected?: boolean
}>`
    display: grid;
    grid-template-columns: ${({ rightElement }) =>
        rightElement ? 'minmax(24px, auto) 1fr auto' : 'minmax(24px, auto) 1fr'};
    align-items: center;
    gap: 6px;
    margin-bottom: ${({ isLastItem }) => (isLastItem ? '0' : '8px')};
    padding: 0 5px;
    cursor: ${({ disabled, isTitle, selected }) => {
        if (isTitle) return 'default'
        if (disabled) return 'not-allowed'
        if (selected) return 'default'
        return 'pointer'
    }};
    ${({ isTitle, theme, selected, disabled }: { isTitle?: boolean; theme?: TTheme; selected?: boolean; disabled?: boolean }) =>
        !isTitle && !selected && !disabled &&
        `
            &:hover {
                background-color: ${theme?.colors.greys[100]};
                border-radius: 4px;
            }
        `}
    ${({ leftIcon }) =>
        !leftIcon &&
        `
            padding: 0 10px;
        `}
    ${({ selected, theme }) =>
        selected &&
        `
            background-color: ${theme?.colors.semantic.overviewListItemIconBackground};
            border-radius: 4px;
        `}
`

export const StyledTypography = styled(Typography)<{
    disabled?: boolean
    isTitle?: boolean
    theme?: TTheme
}>`
    color: ${({ disabled, isTitle, theme }) => {
        if (disabled || isTitle) return theme.colors.greys[400]
        return theme.colors.greys[600]
    }};
    p {
        max-width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        padding: 5px 0;
        margin-right: 5px;
    }
`

export const SimpleMenuItem = styled('div')<{ active?: boolean }>`
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 400;
    font-size: var(--font-size-s);
    line-height: 16px;
    transition: all 0.2s linear;
    cursor: pointer;

    &:hover {
        color: var(--color-dark-500);

        &:before {
            background-color: var(--color-dark-800);
        }
    }
`
export const LeftIconContainer = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
`

export const RightElementContainer = styled('div')`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: 8px;
`
